<template>
  <div class="camera-box">
    <van-nav-bar title="扫一扫" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <qrcode-stream
        v-show="qrcode"
        :camera="camera"
        :torch="torchActive"
        @decode="onDecode"
        @init="onInit"
    >
      <div>
          <div class="qr-scanner">
              <div class="box">
                  <div class="line"></div>
                  <div class="angle"></div>
              </div>
              <div class="txt">
                  将二维码/条码放入框内，即自动扫描
              </div>
              <div class="myQrcode" @click="switchCamera">切换摄像头</div>
          </div>
      </div>
  </qrcode-stream>
</div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import tokenVerify from '@/utils/lib/token-verify'; //token验证
export default {
  components: { QrcodeStream },
  data () {
    return {
      flag:false,//避免多次请求
      imei:'',//
      myTimer:null,//定时器
      result: '', // 扫码结果信息
      error: '', // 错误信息
      // show: false,
      // qrcode: false,
      qrcode: true,
      torchActive: false,
      camera: 'rear',
      goback:false,
    }
  },
  created(){
    if(this.$route.query.data){
      this.goback = this.$route.query.data
      console.log(this.goback,2)
    }
  },
  mounted() {

  },
  beforeUnmount() {

  },
  methods: {
    /**
     * 返回上一级
     */
    backPage() {
        this.$router.back(-1);
    },
    onDecode(result) {
          this.result = result;
          if(this.result && this.result.length>10){
            setTimeout(()=>{
              this.myScanCode(this.result)
            },100)
          }
      },
      switchCamera () {
        switch (this.camera) {
          case 'front':
            this.camera = 'rear'
            break
          case 'rear':
            this.camera = 'front'
            break
        }
      },
      async onInit(promise) {
          const { capabilities } = await promise;

          const TORCH_IS_SUPPORTED = !!capabilities.torch;
          try {
              await promise;
          } catch (error) {
              if (error.name === 'NotAllowedError') {
                  this.error = 'ERROR: 您需要授予相机访问权限';
              } else if (error.name === 'NotFoundError') {
                  this.error = 'ERROR: 这个设备上没有摄像头';
              } else if (error.name === 'NotSupportedError') {
                  this.error = 'ERROR: 所需的安全上下文(HTTPS、本地主机)';
              } else if (error.name === 'NotReadableError') {
                  this.error = 'ERROR: 相机被占用';
              } else if (error.name === 'OverconstrainedError') {
                  this.error = 'ERROR: 安装摄像头不合适';
              } else if (error.name === 'StreamApiNotSupportedError') {
                  this.error = 'ERROR: 此浏览器不支持流API';
              }
          }
      },
    myScanCode(str){
      if(this.goback){
        let num = str.indexOf("@")==-1?str.length:str.indexOf("@")
        this.imei=str.substring(0, num);
        this.$store.commit('set_changeImei', this.imei);
        this.backPage()
        return
      }
      if(this.flag) return
      if(this.myTimer!=null){
        clearTimeout(this.myTimer);
        this.myTimer = null
      }
      this.flag = true
      let num = str.indexOf("@")==-1?str.length:str.indexOf("@")
      this.imei=str.substring(0, num);
      let data = {
        ver:1,
        method:'scanCodeDevice',
        imei:this.imei
      }
      this.$http.post(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.flag = true
            tokenVerify(res.data.token)
            this.$router.push({ name: "location" });
          } else{
            this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
            this.myTimer = setTimeout(()=>{
              this.flag = false
            },3000)
          }
      })
      // 校验扫描结果，并处理
      // let res = e.mp.detail.result
    },
  },
  // 
  destroyed() {
    this.flag = true
    if(this.myTimer!=null){
      clearTimeout(this.myTimer);
      this.myTimer = null
    }
  }
}
</script>

<style lang="scss" scoped>
.camera-box{
  width: 100%;
  height: 100vh;
}
.error {
  font-weight: bold;
  color: red;
}
.cameraMessage {
  width: 100%;
  height: 60px;
}
.qr-scanner {
  background-image: linear-gradient(
          0deg,
          transparent 24%,
          rgba(32, 255, 77, 0.1) 25%,
          rgba(32, 255, 77, 0.1) 26%,
          transparent 27%,
          transparent 74%,
          rgba(32, 255, 77, 0.1) 75%,
          rgba(32, 255, 77, 0.1) 76%,
          transparent 77%,
          transparent
      ),
      linear-gradient(
          90deg,
          transparent 24%,
          rgba(32, 255, 77, 0.1) 25%,
          rgba(32, 255, 77, 0.1) 26%,
          transparent 27%,
          transparent 74%,
          rgba(32, 255, 77, 0.1) 75%,
          rgba(32, 255, 77, 0.1) 76%,
          transparent 77%,
          transparent
      );
  background-size: 3rem 3rem;
  background-position: -1rem -1rem;
  width: 100%;
  /* height: 100%; */
  height: 100vh;
  /* height: 288px; */
  position: relative;
  background-color: #1110;
}
.qr-scanner .box {
  width: 330px;
  height: 330px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border: 0.1rem solid rgba(0, 255, 51, 0.2);
}
.qr-scanner .txt {
  width: 100%;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  text-align: center;
  /* color: #f9f9f9; */
  margin: 0 auto;
  position: absolute;
  top: 70%;
  left: 0;
}
.qr-scanner .myQrcode {
  position: absolute;
  top: 10%;
  right: 30px;
  text-align: center;
  border-radius: 20px;
  background-color: #01ADA9;
  color: #fff;
  width: 140px;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
}
.qr-scanner .line {
  height: calc(100% - 2px);
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 255, 51, 0) 43%, #00ff33 211%);
  border-bottom: 3px solid #00ff33;
  transform: translateY(-100%);
  animation: radar-beam 2s infinite alternate;
  animation-timing-function: cubic-bezier(0.53, 0, 0.43, 0.99);
  animation-delay: 1.4s;
}

.qr-scanner .box:after,
.qr-scanner .box:before,
.qr-scanner .angle:after,
.qr-scanner .angle:before {
  content: '';
  display: block;
  position: absolute;
  width: 3vw;
  height: 3vw;

  border: 0.2rem solid transparent;
}

/* .qr-scanner .box:after,
.qr-scanner .box:before {
  top: 0;
  border-top-color: #00ff33;
}

.qr-scanner .angle:after,
.qr-scanner .angle:before {
  bottom: 0;
  border-bottom-color: #00ff33;
}

.qr-scanner .box:before,
.qr-scanner .angle:before {
  left: 0;
  border-left-color: #00ff33;
}

.qr-scanner .box:after,
.qr-scanner .angle:after {
  right: 0;
  border-right-color: #00ff33;
} */

@keyframes radar-beam {
  0% {
      transform: translateY(-100%);
  }

  100% {
      transform: translateY(0);
  }
}
</style>
<style>

</style>
